export default function truncateToTwoDecimals(number) {
    return Math.floor(number * 100.0) / 100.0
}
